import React from 'react';
import useReveal from '../hooks/useReveal';

const stats = [
  { value: '20+', label: 'Anni di esperienza' },
  { value: '300+', label: 'Clienti seguiti' },
  { value: '99.9%', label: 'Uptime garantito' },
  { value: '24/7', label: 'Monitoraggio attivo' }
];

const ExtraInfo = () => {
  const [refIntro, visibleIntro] = useReveal();
  const [refStats, visibleStats] = useReveal();
  const [refValues, visibleValues] = useReveal();

  return (
    <section id="about" className="extra-section">
      <span id="contact"></span>

      {/* Intro */}
      <div
        ref={refIntro}
        className={`extra-container reveal${visibleIntro ? ' reveal-visible' : ''}`}
      >
        <h2 className="section-title">Chi siamo</h2>
        <p>
          EDP Squared nasce dall'unione di esperienza sul campo e visione strategica nel mondo
          dell'IT. Siamo un team di sistemisti, ingegneri di rete e specialisti della sicurezza
          informatica con sede ad Ancona, operativi su scala nazionale. Da vent'anni
          affianchiamo PMI, aziende strutturate ed enti nella progettazione e nella gestione delle
          loro infrastrutture tecnologiche.
        </p>
        <p>
          Non siamo semplici rivenditori di prodotti: siamo partner tecnologici nel senso più
          pieno del termine. Seguiamo ogni progetto dall'analisi iniziale al supporto
          post-implementazione, garantendo continuità, aggiornamento e presidio costante. Il
          nostro obiettivo è che la tecnologia lavori per voi, non contro di voi.
        </p>
      </div>

      {/* Stats */}
      <div
        ref={refStats}
        className={`extra-stats reveal${visibleStats ? ' reveal-visible' : ''}`}
      >
        {stats.map((s, i) => (
          <div key={i} className="stat-item" style={{ transitionDelay: `${i * 0.12}s` }}>
            <span className="stat-value">{s.value}</span>
            <span className="stat-label">{s.label}</span>
          </div>
        ))}
      </div>

      {/* Values */}
      <div
        ref={refValues}
        className={`extra-values reveal${visibleValues ? ' reveal-visible' : ''}`}
      >
        <div className="value-item">
          <h4>Proattività</h4>
          <p>
            Non aspettiamo che i problemi si manifestino. Monitoriamo, analizziamo e interveniamo
            prima che un'anomalia diventi un incidente critico.
          </p>
        </div>
        <div className="value-item">
          <h4>Competenza certificata</h4>
          <p>
            Il nostro team mantiene certificazioni aggiornate sui prodotti e sulle piattaforme che
            gestiamo, garantendo sempre la massima qualità tecnica.
          </p>
        </div>
        <div className="value-item">
          <h4>Relazione di fiducia</h4>
          <p>
            Costruiamo rapporti duraturi con i nostri clienti. Siamo un riferimento costante, non
            un fornitore anonimo: conosciamo la vostra infrastruttura meglio di chiunque altro.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ExtraInfo;
